import React from 'react';
import { Container, Col, Row } from '../../components/grid';
import {
  Heading1,
  Heading2,
  Heading3,
  LinkStyled,
  Paragraph,
  List,
  Bold,
} from '../../components/typography';
import { ItemTraverser } from '../../containers/commerce';
import SidemenuLayout from '../../layout/DefaultLayout/Layouts/SidemenuLayout';
import ProductView1 from '../../components/commerce/ProductViews/ProductView1';
import RowProductView from '../../components/grid/RowProductView';

export default () => (
  <SidemenuLayout menuPicker="Fadoel" activeSidemenu="Ale">
    <Container white mb>
      <Row>
        <Col xs={12} paddingBottom="0px">
          <Heading1>Ale</Heading1>
        </Col>
        <Col md={12} paddingTop="0px">
          <Paragraph>
            Forkæl dine smagsløg med en ale. Der findes flere typer ale, men fælles for dem alle er, at de er overgæret. Dette er med til at give øllen en sødere og mere frugtig smag, modsat almindelig pilsner. Den sødlige smag balanceres med humle, der skaber en afbalanceret smag mellem sødme og bitterhed. Hos Skafte finder du et bredt sortiment af både brown, mørk og lys ale på fad. Husk, at du også kan leje et <LinkStyled to="/fadoelsanlaeg">fadølsanlæg</LinkStyled> hos Skafte, så du kan servere den skønne ale øl på fad.
          </Paragraph>
        </Col>
      </Row>
    </Container>
    <Container>
      <RowProductView>
        <ItemTraverser category="fadoelAle" display={ProductView1} showTypeFadoel filterFadkobling filterLiterSize filterLiterPrice />
      </RowProductView>
    </Container>
    <Container white mb>
      <Row>
        <Col xs={12}>
          <Heading2>Hvad er ale?</Heading2>
          <Paragraph>
            Ale er en overgæret øl, der fås i mange forskellige varianter, herunder lys og mørk.
            Ale begrebet dækker typisk over alle typer overgæret øl, hvilket også betyder, at utroligt mange specialøl kan kategoriseres som værende ale. De mest kendte ales er brown ale, pale ale, IPA (india pale ale) og porter.
          </Paragraph>
          <Paragraph>
            Når der er tale om overgæret øl, foregår gæringen ofte mellem 20-30 grader over 3-6 døgn, hvilket er forholdsvis hurtigt. De høje temperaturer gør gæren så aktiv, at den er med til at danne et meget tykt lag skum i toppen af beholderen. Når processen for overgæring er slut, bliver ale øllen færdigmodnet enten på flaske eller fad, hvilket afhænger af typen.
          </Paragraph>
          <Paragraph>
            Ale er selvfølgelig en type af øl, hvilket betyder, at den brygget på både gær, malt og humle. Dog adskiller ale øl sig fra almindelig pilsner, ved at der bruges en anden type gær. Her bruges nemlig en såkaldt overgær, der er med til at omdanne stivelsen til sukker meget hurtigere. Overgæren er med til at give en både sødere og mere frugtagtig smag til alen. Den tilsatte humle er med til at modvirke den lidt søde smag ved at tilføre bitterhed. Ale byder oftest på mere maltaroma end andre typer øl, grundet de højere gæringstemperaturer.
          </Paragraph>
        </Col>
      </Row>
    </Container>
    <Container white mb>
      <Row>
        <Col xs={12}>
          <Heading2>Vælg mellem flere slags ale på fad</Heading2>
          <Paragraph>
            Hos Skafte finder du et bredt udvalg af lækker ale på fad, så du kan med garanti finde en, der kæler for netop dine smagsløg. Blandt vores sortiment finder du både brown ale, mørk ale og lys ale. Læs mere om de forskellige typer nedenfor og find din favorit:
          </Paragraph>
        </Col>
      </Row>
    </Container>
    <Container white mb>
      <Row>
        <Col xs={12}>
          <Heading3><LinkStyled to="/fadoel/ale/brown-ale">Brown ale</LinkStyled></Heading3>
          <Paragraph>
            I brown ale finder du en lavere mængde humle, hvilket er med til at give ale øllen en mildere smag. Brown ale har en lav bitterhed og en let-middel sødme. Farven kan variere fra kobberfarvet til mørkebrun og opnås på baggrund af den mørke malt.
            Blandt vores sortiment af brown ale finder du følgende på fad:
          </Paragraph>
          <List>
            <li>Ale no. 16</li>
            <li>Hornbeer Øko Red Cow Brown Ale</li>
            <li>Newcastle Brown Ale</li>
            <li>NidaBeer Brown Ale</li>
            <li>Skovlyst Bøgebryg</li>
          </List>
        </Col>
      </Row>
    </Container>
    <Container white mb>
      <Row>
        <Col xs={12}>
          <Heading3><LinkStyled to="/fadoel/ale/moerk-ale">Mørk ale</LinkStyled></Heading3>
          <Paragraph>
            En mørk ale har som oftest en blød, rund og fyldig smag, mens den også har tendens til en kraftig sødme. Denne ale har en humlet og intens aroma, der suppleres af karakterer af både nødder og tørrede frugter.
            Blandt vores sortiment af mørk ale finder du følgende på fad:
          </Paragraph>
          <List>
            <li>Herslev Øko Hyben</li>
            <li>Herslev Øko India Dark Ale</li>
            <li>Leffe Brune</li>
            <li>Muphy&apos;s Red Ale</li>
            <li>Nørrebro Øko Ravnsborg Rød</li>
          </List>
        </Col>
      </Row>
    </Container>
    <Container white mb>
      <Row>
        <Col xs={12}>
          <Heading3><LinkStyled to="/fadoel/ale/lys-ale">Lys ale</LinkStyled></Heading3>
          <Paragraph>
            Denne ale er også kendt som “pale ale”. En ravgylden ale med en middel sødme fra malt, en middel bitterhed og en middel frugtighed. Meget velbalanceret, især når det gælder mængden af lys malt og humle.
            Blandt vores sortiment af lys ale finder du følgende på fad:
          </Paragraph>
          <List>
            <li>Affligem Blonde</li>
            <li>Fuglsang Early Bird</li>
            <li>Fynsk Forår</li>
            <li>Grimbergen Blonde</li>
            <li>Herslev Øko Pale Ale</li>
            <li>Leffe Blonde</li>
            <li>NidaBeer Pale Ale</li>
            <li>Nørrebro Øko Dronning Louises Paaske Ale</li>
          </List>
        </Col>
      </Row>
    </Container>
    <Container white mb>
      <Row>
        <Col xs={12}>
          <Heading2>Derfor skal du vælge en ale</Heading2>
          <Paragraph>
            Hvis du er typen, der godt kan lide smagen af øl, men samtidig værdsætter at prøve noget andet end de helt klassiske (men også gode) valg, så er ale øl en sikker vinder. Uanset om du er inkarneret øl-kender eller bare elsker at prøve noget nyt og udvide horisonten, så er ale et rigtig godt bud på en øl, der ikke vil skuffe.
          </Paragraph>
          <Paragraph>
            Men hvad er ales største fordele?:
          </Paragraph>
          <List>
            <li><Bold>Rig smagsprofil: </Bold>Ales har en dybde af smag, der kan variere lige fra søde, frugtagtige toner til de dybe, maltrige og endda de bitre toner. De mange smagsprofiler betyder, at du altid kan finde en ale til din og dine gæsters smag.</li>
            <li><Bold>Utallige varianter: </Bold>Det er ikke kun de mange smagsprofiler, du kan nyde godt af ved ale. Du kan nemlig også finde flere varianter af ale, som nævnt i afsnittet ovenfor. Find din favorit blandt brown ale, india pale ale, mørk ale og flere.</li>
            <li>
              <Bold>Ale går rigtig godt til maden: </Bold>De mange smagsprofiler ved ale gør, at det altid er muligt at parre en lækker ale til middagen. Det er ikke kun vin, der kan løfte et måltid, men en godt valg ale vil komplimentere forskellige retter og understøtte alt lige fra stærke oste, grillretter, skaldyr eller endda chokoladedesserter.
              <List>
                <li>Pale ale: Prøv en pale ale til grillede retter, burgere, salater, stegt kylling eller cheddarost. Den moderate bitterhed fra humlen kan både komplimentere men også skære igennem fedt, mens de maltede noter matcher de lidt karamelliserede smage fra grillen.</li>
                <li>Brown ale: Prøv denne ale til pølser, grillet kød, stuvninger og modne oste. Denne type ale øl har nøddeagtige og maltede noter, der matcher godt til de rige smage i disse retter.</li>
                <li>Mørk ale: Denne ale passer særligt godt til grillet og røget kød, oksekød, lam, chokolade, kaffedesserter, gryderetter og blå ost. Alen har oftest en rig og kompleks smagsprofil med noter af malt, karamel, chokolade og kaffe.</li>
              </List>
            </li>
          </List>
          <Paragraph>Bestil en fustage eller to med ale til din næste fest eller arrangement - du vil ikke fortryde det!</Paragraph>
        </Col>
      </Row>
    </Container>
    <Container white>
      <Row>
        <Col xs={12}>
          <Heading2>Lad Skafte levere din næste ale øl på fad</Heading2>
          <Paragraph>
            Gå på opdagelse blandt vores udvalg af ale på fad, der forkæler dine sanser og slukker tørsten på køligste vis.
            Bestil allerede i dag og få leveret til din næste fest, bryllup, fødselsdag, event eller lignende. Husk at du også kan leje fadølsanlæg hos Skafte, når du alligevel bestiller ale på fad.
          </Paragraph>
          <Paragraph>
            Skafte leverer inden for 1-2 dage, hvis du bestiller inden for almindelig arbejdstid.
          </Paragraph>
        </Col>
      </Row>
    </Container>
  </SidemenuLayout>
);
